module.exports = require("/Users/asd/Projects/buybags/frontend/src/gatsby-browser.ts");